import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ee285bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer bg-light border-top position-fixed bottom-0 w-100 py-3" }
const _hoisted_2 = {
  key: 0,
  class: "section-partners"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "container-fluid d-flex justify-content-between align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Powered by "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.getmap.eu",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      width: "36",
      src: "https://nano-explore.getmap.gr/get-small-logo.png",
      alt: "GET logo"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Partners = _resolveComponent("Partners")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    (_ctx.$route.name !== 'Home')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Partners),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, "Copyright © 2021" + _toDisplayString(new Date().getFullYear() === 2021 ? '' : ` - ${new Date().getFullYear()}`), 1),
      _hoisted_5
    ])
  ]))
}